import React, { ReactNode } from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Portal,
} from '@chakra-ui/react';

interface PopoverWrapperProps {
  trigger: ReactNode;
  content: any;
  onClose?: () => void;
  isOpen?: boolean;
  containerRef?: any;
}

const PopoverWrapper = ({
  trigger,
  content,
  onClose,
  isOpen,
  containerRef,
}: PopoverWrapperProps) => {
  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-start">
      {/* @ts-ignore - Need to update chakra-ui to 2.x.x */}
      <PopoverTrigger>{trigger}</PopoverTrigger>
      <Portal containerRef={containerRef}>
        <PopoverContent w="auto" minW="unset" style={{ left: 0 }}>
          <PopoverBody>{content}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default PopoverWrapper;
